import { AlternativeAutoComplete } from 'common/form/autoComplete/_alternativeAutoComplete'
import { Option } from 'common/form/autoComplete/_option'
import {useHistoryOrderFilterForm} from "../../../../hooks/useHistoryOrderFilterForm";

export const Teacher = () => {
  const { teacher } = useHistoryOrderFilterForm()

  return (
    <AlternativeAutoComplete
      className="order-filter-form__input-wide"
      // main input
      inputProps={{
        categoryList: [], // menu list in category dropdown
        categoryValue: { name: 'ĐL cấp 2', value: '' }, // if not exist this value -> default category: categoryList[0]
        categoryWidth: 82,
        placeholder: 'Chọn ĐL cấp 2',
        readOnly: true,
        value: teacher.value?.name || '',
        onIconClick: () => teacher.onChange(null),
      }}
      // menu
      menuProps={{
        empty:
          teacher.listOrigin.length <= 0
            ? 'Vui lòng chọn ĐL cấp 1'
            : teacher.list.length <= 0 ? 'Không tìm thấy ĐL cấp 2' : '',
      }}
      // search input in dropdown menu
      searchInputProps={{
        placeholder: 'Tìm kiếm ĐL cấp 2',
        value: teacher.keyword,
        onChange: teacher.onKeywordChange,
      }}
    >
      {teacher.list.length > 0 &&
      teacher.list.map(item => (
        <Option
          key={item.value}
          className="order-filter-form__option-text"
          data-active={item.value === teacher.value?.value}
          onClick={() => teacher.onChange(item)}
        >
          {item.name}
        </Option>
      ))}
    </AlternativeAutoComplete>
  )
}
